import { motion } from 'framer-motion';
import { Home, SquarePlay, Brain, User } from 'lucide-react';

interface MobileBottomNavProps {
  activeView: string;
  onViewChange: (view: string) => void;
  isDarkMode?: boolean;
}

const navItems = [
  { id: 'হোম', label: 'হোম', icon: Home },
  { id: 'কোর্সসমূহ', label: 'কোর্সসমূহ', icon: SquarePlay },
  { id: 'চর্চাঘর', label: 'অনুশীলন', icon: Brain },
  { id: 'প্রোফাইল', label: 'প্রোফাইল', icon: User },
];

export default function MobileBottomNav({ activeView, onViewChange }: MobileBottomNavProps) {
  return (
    <div 
      className="lg:hidden fixed bottom-0 left-0 right-0 w-full bg-white dark:bg-[#121212] border-t border-gray-100 dark:border-white/5 px-2 pt-2.5 pb-[calc(10px+env(safe-area-inset-bottom))] flex justify-around items-center z-50 shadow-[0_-4px_16px_rgba(0,0,0,0.03)]"
      aria-label="মোবাইল নেভিগেশন বার"
    >
      <div className="flex w-full items-center justify-around">
        {navItems.map((item) => {
          const isActive = activeView === item.id;
          const Icon = item.icon;

          return (
            <button
              key={item.id}
              onClick={() => onViewChange(item.id)}
              className="flex flex-col items-center justify-center gap-1 cursor-pointer select-none active:scale-95 transition-transform"
              aria-label={item.label}
              aria-current={isActive ? 'page' : undefined}
            >
              {/* Icon Container with active pill background */}
              <div className="relative flex items-center justify-center px-6 py-1.5 rounded-full overflow-hidden transition-all duration-300">
                {isActive && (
                  <motion.div
                    layoutId="activeNavBackground"
                    className="absolute inset-0 bg-[#E8F2FE] dark:bg-[#1E293B] rounded-full"
                    transition={{ type: 'spring', stiffness: 350, damping: 26 }}
                  />
                )}
                
                <Icon 
                  className={`w-5.5 h-5.5 relative z-10 transition-colors duration-300 ${
                    isActive 
                      ? 'text-[#00A3FF] dark:text-[#8AB4F8] stroke-[2.5]' 
                      : 'text-[#94A3B8] dark:text-[#5F6368] stroke-[2]'
                  }`} 
                />
              </div>

              {/* Text Label Below */}
              <span 
                className={`font-bangla text-[11px] font-bold transition-colors duration-300 leading-none mt-0.5 ${
                  isActive 
                    ? 'text-[#00A3FF] dark:text-[#8AB4F8]' 
                    : 'text-[#94A3B8] dark:text-[#5F6368]'
                }`}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
